import React, { useMemo } from "react";
import { Modal, Table, Spinner, Button } from "react-bootstrap";
import CustomPagination from "../../comman/CustomPagination";
import CloseBtn from "../CloseBtn";
import SimpleTable from "../../comman/custom-table/SimpleTable";

const fmtDate = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "-";

const addr = (d) => {
  const parts = [d?.address, d?.city, d?.state, d?.pincode].filter(Boolean);
  return parts.length ? parts.join(", ") : "-";
};

const RedispatchListModal = ({
  show,
  onHide,
  order,
  loading,
  list,
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
}) => {
  const columns = useMemo(
    () => [
      {
        id: "serial",
        header: "#",
        minWidth: 60,
        sortable: false,
        cell: (_v, row) => row.serial,
      },
      {
        id: "client",
        header: "Client",
        accessor: "name",
        sortType: "text",
        minWidth: 160,
      },
      {
        id: "phone",
        header: "Phone",
        accessor: "phone",
        sortType: "text",
        minWidth: 120,
      },
      {
        id: "address",
        header: "Address",
        accessor: "address",
        sortType: "text",
        className: "whitespace-pre-wrap",
        minWidth: 220,
        cell: (v) => <span style={{ whiteSpace: "pre-wrap" }}>{v}</span>,
      },
      {
        id: "delay_reason",
        header: "Delay Reason",
        accessor: "delay_reason",
        sortType: "text",
        minWidth: 160,
      },
      {
        id: "status",
        header: "Status",
        accessor: "status",
        sortType: "text",
        minWidth: 120,
      },
      {
        id: "tracking_no",
        header: "Tracking No",
        accessor: "tracking_no",
        sortType: "text",
        minWidth: 160,
      },
      {
        id: "courier",
        header: "Courier",
        accessor: "courier_name",
        sortType: "text",
        minWidth: 140,
      },
      {
        id: "mode",
        header: "Mode",
        accessor: "courier_mode",
        sortType: "text",
        minWidth: 120,
      },
      {
        id: "redispatch_date",
        header: "Redispatch Date",
        // sort on raw date, display formatted
        accessor: "dateRaw",
        sortType: "date",
        minWidth: 160,
        cell: (_v, row) => row.dateStr,
      },
      {
        id: "remark",
        header: "Remark",
        accessor: "remark",
        sortType: "text",
        minWidth: 200,
      },
      {
        id: "tat",
        header: "TAT",
        accessor: "tat",
        // often numeric; auto will handle text too
        sortType: "auto",
        minWidth: 100,
      },
      {
        id: "track",
        header: "Track",
        sortable: false,
        minWidth: 110,
        cell: (_v, row) =>
          row.tracking_url ? (
            <Button
              as="a"
              href={row.tracking_url}
              target="_blank"
              rel="noreferrer"
              size="sm"
              variant="outline-primary"
              onClick={(e) => e.stopPropagation()}
            >
              Open
            </Button>
          ) : (
            "—"
          ),
      },
    ],
    []
  );
  const rows = useMemo(
    () =>
      (Array.isArray(list) ? list : []).map((d, i) => {
        const serial = (page - 1) * pageSize + (i + 1);
        const name = d?.client?.name ?? d?.client_name ?? "—";
        const phone = d?.mobile ?? d?.phone ?? "—";
        const address = addr(d);
        const delay_reason = d?.delay_reason ?? "—";
        const status = d?.status ?? "—";
        const tracking_no = d?.tracking_no ?? "—";
        const courier_name = d?.courier_name ?? "—";
        const courier_mode = d?.courier_mode ?? "—";
        const dateRaw = d?.redispatch_date ?? d?.dispatch_date ?? null;
        const dateStr = fmtDate(dateRaw);
        const remark = d?.redispatch_remark ?? d?.dispatch_remark ?? "—";
        const tat = d?.redispatch_tat ?? d?.dispatch_tat ?? "—";
        const tracking_url = d?.tracking_url;

        return {
          id: d?.id ?? `${serial}`, // keyField
          serial,
          name,
          phone,
          address,
          delay_reason,
          status,
          tracking_no,
          courier_name,
          courier_mode,
          dateRaw, // for sorting
          dateStr, // for display
          remark,
          tat,
          tracking_url,
        };
      }),
    [list, page, pageSize, addr, fmtDate]
  );
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={list?.length > 0 ? "xl" : "md"}
      // size="xl"
      centered
    >
      <CloseBtn onClick={onHide} color="#bf352b" />
      <Modal.Header>
        <Modal.Title>
          Redispatches &mdash; Order {order?.order_no ?? order?.id}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {list?.length > 0 ? (
        <>
          {/* <div className="position-relative table-cover">
              {loading && (
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                  style={{ background: "rgba(255,255,255,0.6)", zIndex: 2 }}
                >
                  <Spinner animation="border" />
                </div>
              )}

              <Table bordered responsive hover size="sm">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Client</th>
                    <th>Phone</th>
                    <th>Address</th>
                    <th>Delay Reason</th>
                    <th>Status</th>
                    <th>Tracking No</th>
                    <th>Courier</th>
                    <th>Mode</th>
                    <th>Redispatch Date</th>
                    <th>Remark</th>
                    <th>TAT</th>
                    <th>Track</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(list) && list.length > 0 ? (
                    list.map((d, idx) => (
                      <tr key={d.id || idx}>
                        <td>{(page - 1) * pageSize + (idx + 1)}</td>
                        <td>{d?.client?.name ?? d?.client_name ?? "-"}</td>
                        <td>{d?.mobile ?? d?.phone ?? "-"}</td>
                        <td style={{ whiteSpace: "pre-wrap" }}>{addr(d)}</td>
                        <td>{d?.delay_reason ?? "-"}</td>
                        <td>{d?.status ?? "-"}</td>
                        <td>{d?.tracking_no ?? "-"}</td>
                        <td>{d?.courier_name ?? "-"}</td>
                        <td>{d?.courier_mode ?? "-"}</td>
                        <td>
                          {fmtDate(d?.redispatch_date ?? d?.dispatch_date)}
                        </td>
                        <td>
                          {d?.redispatch_remark ?? d?.dispatch_remark ?? "-"}
                        </td>
                        <td>{d?.redispatch_tat ?? d?.dispatch_tat ?? "-"}</td>
                        <td>
                          {d?.tracking_url ? (
                            <Button
                              as="a"
                              href={d.tracking_url}
                              target="_blank"
                              rel="noreferrer"
                              size="sm"
                              variant="outline-primary"
                            >
                              Open
                            </Button>
                          ) : (
                            "-"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={13} className="text-center text-muted">
                        No redispatches found
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div> */}
          <SimpleTable
            data={rows}
            columns={columns}
            loading={loading}
            keyField="id"
            responsive
            size="sm"
            emptyMessage={"no records found"}
            headerSticky
            tableProps={{ bordered: true, hover: true, className: "mb-0" }}
          />
          <div className="text-muted small">Total: {total}</div>
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={onPageChange}
            loading={loading}
            pageSize={pageSize}
            setPageSize={() => {}}
            setCurrentPage={() => {}}
            total={total}
          />
        </>
      ) : (
          <h4 className="text-center">No records found</h4>
        )} 
      </Modal.Body>

      <Modal.Footer className="justify-content-end">
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RedispatchListModal;
